import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98eece1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-color-warning" }
const _hoisted_2 = { class: "ion-color-warning" }
const _hoisted_3 = { class: "ion-color-warning" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label-text sc-ion-input-md",
  style: {"font-size":"12px"}
}, "Data di nascita*", -1))
const _hoisted_5 = { class: "ion-color-warning" }
const _hoisted_6 = { class: "ion-color-warning" }
const _hoisted_7 = { class: "ion-color-warning" }
const _hoisted_8 = { class: "ion-color-warning" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recapito Personale", -1))
const _hoisted_10 = { class: "ion-color-warning" }
const _hoisted_11 = { class: "ion-color-warning" }
const _hoisted_12 = { class: "ion-color-warning" }
const _hoisted_13 = { class: "ion-color-warning" }
const _hoisted_14 = { class: "ion-color-warning" }
const _hoisted_15 = { class: "ion-color-warning" }
const _hoisted_16 = { class: "ion-color-warning" }
const _hoisted_17 = { class: "ion-color-warning" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Dati Azienda", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_field = _resolveComponent("field")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_VForm = _resolveComponent("VForm")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { translucent: true }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, { "default-href": "/" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Modifica profilo")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_VForm, { ref: "formData" }, {
            default: _withCtx(({ errors }) => [
              (_ctx.user)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            labelPlacement: "floating",
                            label: "Data iscrizione",
                            value: _ctx.user.dataiscr,
                            readonly: true
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "cognome",
                            rules: "required",
                            modelValue: _ctx.user.cognome,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.cognome) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                labelPlacement: "floating",
                                label: "Cognome"
                              }, field), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_1, _toDisplayString(errors.cognome), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "nome",
                            rules: "required",
                            modelValue: _ctx.user.nome,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.nome) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                labelPlacement: "floating",
                                label: "Nome",
                                name: "nome"
                              }, field), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(errors.nome), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "codice fiscale",
                            rules: "required",
                            modelValue: _ctx.user.cfisc,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.cfisc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                labelPlacement: "floating",
                                label: "Codice Fiscale"
                              }, field, { readonly: true }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(errors['codice fiscale']), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "data di nascita",
                            rules: "required",
                            modelValue: _ctx.user.datanasc,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.datanasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createElementVNode("div", null, [
                                _hoisted_4,
                                _createVNode(_component_ion_datetime_button, { datetime: "birth-date-picker" })
                              ]),
                              _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_datetime, _mergeProps({
                                    id: "birth-date-picker",
                                    presentation: "date",
                                    "prefer-wheel": true
                                  }, field), null, 16)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(errors['data di nascita']), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "nazione di nascita",
                            rules: "required",
                            modelValue: _ctx.user.naznasc,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.naznasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                labelPlacement: "floating",
                                label: "Nazione di nascita"
                              }, field, { type: "text" }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(errors['nazione di nascita']), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "provincia di nascita",
                            rules: "required",
                            modelValue: _ctx.user.pvnasc,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.pvnasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                labelPlacement: "floating",
                                label: "Provincia di nascita"
                              }, field, { type: "text" }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(errors['provincia di nascita']), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_field, {
                            name: "comune di nascita",
                            rules: "required",
                            modelValue: _ctx.user.comnasc,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.comnasc) = $event))
                          }, {
                            default: _withCtx(({field}) => [
                              _createVNode(_component_ion_input, _mergeProps({
                                labelPlacement: "floating",
                                label: "Comune di Nascita"
                              }, field, { type: "text" }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(errors['comune di nascita']), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item_divider, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "indirizzo",
                                rules: "required",
                                modelValue: _ctx.user.recindir,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.recindir) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Indirizzo"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(errors.indirizzo), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "nazione",
                                rules: "required",
                                modelValue: _ctx.user.recnaz,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.recnaz) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Nazione"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(errors.nazione), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "provincia",
                                rules: "required",
                                modelValue: _ctx.user.recpv,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.recpv) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Provincia"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(errors.provincia), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "comune",
                                rules: "required",
                                modelValue: _ctx.user.reccom,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.reccom) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Comune"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(errors.comune), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "cap",
                                rules: "required",
                                modelValue: _ctx.user.reccap,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.reccap) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "CAP"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(errors.cap), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "email",
                                rules: "required",
                                modelValue: _ctx.user.recemail,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.recemail) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Email"
                                  }, field, {
                                    type: "email",
                                    readonly: true
                                  }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(errors.recemail), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "telefono",
                                rules: "required",
                                modelValue: _ctx.user.recph,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user.recph) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Telefono"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(errors.telefono), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_field, {
                                name: "cellulare",
                                rules: "required",
                                modelValue: _ctx.user.reccell,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.reccell) = $event))
                              }, {
                                default: _withCtx(({field}) => [
                                  _createVNode(_component_ion_input, _mergeProps({
                                    labelPlacement: "floating",
                                    label: "Cellulare"
                                  }, field, { type: "text" }), null, 16)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(errors.cellulare), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_item_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item_divider, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Ragione Sociale",
                                modelValue: _ctx.user.azragsoc,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user.azragsoc) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Codice Fiscale",
                                modelValue: _ctx.user.azcfisc,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.user.azcfisc) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Partita IVA",
                                modelValue: _ctx.user.azpiva,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.azpiva) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Indirizzo",
                                modelValue: _ctx.user.azindir,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.user.azindir) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "CAP/ZIPCode",
                                modelValue: _ctx.user.azcap,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.user.azcap) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Provincia",
                                modelValue: _ctx.user.azpv,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.user.azpv) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Comune",
                                modelValue: _ctx.user.azcom,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.user.azcom) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Comune Estero",
                                modelValue: _ctx.user.azcom,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.user.azcom) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Nazione",
                                modelValue: _ctx.user.aznaz,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.user.aznaz) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Email",
                                modelValue: _ctx.user.azemail,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.user.azemail) = $event)),
                                type: "email"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Telefono",
                                modelValue: _ctx.user.azph,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.user.azph) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                labelPlacement: "floating",
                                label: "Cellulare Aziendale",
                                modelValue: _ctx.user.azcell,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.user.azcell) = $event)),
                                type: "text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_button, {
                shape: "round",
                expand: "block",
                size: "default",
                onClick: $options.save,
                disabled: $data.saving,
                style: {"margin":"15px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Salva "),
                  ($data.saving)
                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                        key: 0,
                        name: "circular"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}